import type { ReactNode } from 'react';
import { ErrorBanner } from '@/components/ErrorBanner';
import { Header } from './Header';
import { Sidebar, RightPanel } from './Sidebar';
import { TabBar } from './TabBar';

export interface AppShellProps {
  children: ReactNode;
  networkLabel?: string;
  networkTone?: 'ok' | 'warn' | 'err';
  onLock?: () => void;
  /** 是否展示右侧信息面板（≥1280px） */
  showRightPanel?: boolean;
}

/**
 * 三档响应式骨架（PRD §7.3）：
 *  - ≥1280px：左栏 + 主区 + 右信息面板（三栏）
 *  - 768–1279px：左栏 + 主区（两栏）
 *  - <768px：单栏 + 底部 Tab
 */
export function AppShell({
  children,
  networkLabel,
  networkTone,
  onLock,
  showRightPanel = true,
}: AppShellProps): JSX.Element {
  return (
    <div className="flex h-full flex-col bg-bg">
      <Header networkLabel={networkLabel} networkTone={networkTone} onLock={onLock} />
      <ErrorBanner />
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main className="min-w-0 flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1200px] p-4 md:p-6">{children}</div>
        </main>
        {showRightPanel ? <RightPanel /> : null}
      </div>
      <TabBar />
    </div>
  );
}

export default AppShell;
